import React from "react";

export default function UpdatePartners() {
  return (
    <section className="bg-white py-16 lg:py-20">
      <div className="container">
        <p className="text-center text-sm font-semibold uppercase tracking-[0.2em] text-slate-500">
          Built on frontier infrastructure · Trusted by industry leaders
        </p>
        <div className="mt-10 flex flex-col items-center justify-center gap-10 lg:flex-row lg:gap-20">
          <img
            className="h-10 w-auto opacity-80 grayscale transition hover:opacity-100 hover:grayscale-0 lg:h-14"
            src="/assets/images/navidia.png"
            alt="NVIDIA"
          />
          <img
            className="h-10 w-auto opacity-80 grayscale transition hover:opacity-100 hover:grayscale-0 lg:h-14"
            src="/assets/images/partners/partner1.png"
            alt="Partner"
          />
        </div>
      </div>
    </section>
  );
}
